/* Sonder 2.0 · B3.1 · E2 — Segunda foto de la tarjeta del catálogo (solo escritorio con ratón).
 * La imagen alternativa no tiene `src` hasta el primer pasaje del cursor por la tarjeta: sin hover real
 * (móvil/táctil) no se descarga nunca. Un único listener delegado: también cubre las tarjetas que añade el
 * scroll infinito o los filtros. */
(function () {
  if (!window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  function arm(card) {
    var alt = card.querySelector('.sdr-cc__img--alt[data-src]');
    if (!alt) return;
    var src = alt.getAttribute('data-src');
    var srcset = alt.getAttribute('data-srcset');
    alt.removeAttribute('data-src');
    alt.addEventListener('load', function () { card.classList.add('sdr-cc--alt-ready'); }, { once: true });
    if (srcset) alt.srcset = srcset;
    alt.src = src;
  }

  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var card = e.target.closest && e.target.closest('.sdr-cc');
    if (card) arm(card);
  }, { passive: true });
})();

/* Sonder 2.0 · B3.1 · E4.2 — Aviso accesible mínimo para rangos de precio invertidos.
 * La corrección del rango la hace el componente nativo (price-facet-component, que ajusta los valores a
 * data-min/data-max); aquí solo se anuncia a lectores de pantalla, en una región fuera de la sección
 * (el filtro se vuelve a pintar tras aplicarse y borraría un aviso interno). */
(function () {
  var live;
  function announce(msg) {
    if (!live) {
      live = document.createElement('div');
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      live.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;overflow:hidden;clip-path:inset(50%);white-space:nowrap';
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 60);
  }
  function num(v) {
    var n = parseFloat(String(v).replace(/[^\d.,]/g, '').replace(',', '.'));
    return isNaN(n) ? null : n;
  }
  /* window en captura: se ejecuta antes que el listener nativo, que ya habría corregido los valores */
  window.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('price-facet__input')) return;
    var box = t.closest('price-facet-component');
    if (!box) return;
    var inputs = box.querySelectorAll('.price-facet__input');
    var lo = num(inputs[0] && inputs[0].value);
    var hi = num(inputs[1] && inputs[1].value);
    if (lo !== null && hi !== null && lo > hi) {
      announce('El precio mínimo no puede ser mayor que el máximo. Se ajustó el rango.');
    }
  }, true);
})();

/* Sonder 2.0 · B3.1 · E4.3 — Buscador de marcas del filtro «Marca».
 * Solo reduce las opciones visibles de la lista (sin distinguir mayúsculas, minúsculas ni acentos); no cambia los
 * resultados del catálogo hasta que se marca una marca (el input no tiene `name`, así que no viaja con el formulario).
 * Los <li> de Horizon llevan data-skip-node-update, por lo que su estilo en línea sobrevive a los repintados. */
(function () {
  function norm(s) {
    return String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  }
  function apply(input) {
    var panel = input.closest('.facets__panel-content');
    if (!panel) return;
    var q = norm(input.value);
    var shown = 0;
    panel.querySelectorAll('.facets__inputs-list-item').forEach(function (li) {
      var t = li.querySelector('.checkbox__label-text');
      var match = !q || norm(t && t.textContent).indexOf(q) !== -1;
      if (!q) li.style.removeProperty('display');
      else li.style.setProperty('display', match ? 'list-item' : 'none', 'important'); /* gana a .hidden de «Ver más» */
      if (match) shown++;
    });
    var msg = panel.querySelector('.sdr-facet-search__empty');
    if (msg) msg.textContent = q && !shown ? 'Ninguna marca coincide' : '';
    var more = panel.querySelector('.show-more__button');
    if (more) more.style.display = q ? 'none' : '';
  }
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('sdr-facet-search__input')) apply(t);
  });
  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('sdr-facet-search__input')) return;
    if (e.key === 'Enter') e.preventDefault(); /* no enviar el formulario de filtros */
  });
})();

/* Sonder 2.0 · B3.1 · E5 — Contador de piezas de la cabecera.
 * Sin filtros: «TOTAL piezas»; con filtros: «N de TOTAL piezas». N sale de `data-results-count` y la presencia de filtros
 * de `data-has-filters`, ambos del propio repintado de Horizon (facets-form-component): el texto cambia en el mismo
 * momento que la lista y no depende de la URL ni de estimaciones. TOTAL (`data-sdr-total`) lo escribe Liquid con
 * collection.all_products_count. La primera carga ya llega renderizada desde Liquid (sin parpadeo). */
(function () {
  var raf = 0;
  function sync() {
    var out = document.querySelector('.sdr-colhead__count');
    var f = document.querySelector('facets-form-component[data-results-count]');
    if (!out || !f) return;
    var total = parseInt(out.getAttribute('data-sdr-total'), 10);
    var shown = parseInt(f.getAttribute('data-results-count'), 10);
    if (isNaN(total) || isNaN(shown)) return;
    var unit = total === 1 ? 'pieza' : 'piezas';
    var txt = f.getAttribute('data-has-filters') === 'true' ? shown + ' de ' + total + ' ' + unit : total + ' ' + unit;
    if (out.textContent.trim() !== txt) out.textContent = txt;
  }
  function schedule() {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(sync);
  }
  new MutationObserver(schedule).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-results-count', 'data-has-filters'] });
  sync();
})();
